function Photo({ color }) {
    return (
        <svg width="25" height="25" fill={color} viewBox="0 0 24 24">
            <g fillRule="evenodd">
                <path
                    d="M448.968 178.925l-.648.057a2.692 2.692 0 01-1.978-.625 2.69 2.69 0 01-.96-1.84l-1.372-15.697a2.702 2.702 0 01.79-2.156c.47-.472 1.111-.731 1.774-.79l2.58-.225a.498.498 0 01.507.675 4.189 4.189 0 00-.251 1.11l-1.393 15.916a4.206 4.206 0 00.977 3.091s.459.364-.026.485m8.524-16.327a1.75 1.75 0 11-3.485.305 1.75 1.75 0 013.485-.305m5.85 3.011a.797.797 0 00-1.129-.093l-3.733 3.195a.545.545 0 00-.062.765l.837.993a.75.75 0 11-1.147.966l-2.502-2.981a.797.797 0 00-1.096-.12L451 171l-.5 4.25c-.06.674.326 2.19 1 2.25l11.916 1.166c.325.026 1-.039 1.25-.25.252-.21.89-.842.917-1.166l.833-8.084-3.073-3.557z"
                    transform="translate(-444 -156)"
                ></path>
                <path
                    fillRule="nonzero"
                    d="M463.61 179.463l-11.604-1.015a2.77 2.77 0 01-2.512-2.995l1.386-15.863a2.77 2.77 0 012.996-2.51l11.603 1.015a2.77 2.77 0 012.513 2.994l-1.388 15.862a2.77 2.77 0 01-2.994 2.513zm.13-1.494l.082.004a1.27 1.27 0 001.287-1.154l1.388-15.862a1.27 1.27 0 00-1.148-1.37l-11.604-1.014a1.27 1.27 0 00-1.37 1.15l-1.387 15.86a1.27 1.27 0 001.149 1.37l11.603 1.016z"
                    transform="translate(-444 -156)"
                ></path>
            </g>
        </svg>
    );
}

export default Photo;
